export const FORM_FIELDS_NAMES = {
    ROLE: "role",
    DESCRIPTION:"description",
    PERMISSION:"permission",
}